export const siteConfig = {
  companyName: 'Atak Sistem Enerji',
  phone: '0266 246 41 59',
  phoneRaw: '+902662464159',
  whatsappNumber: '905492623022',
  email: 'info@ataksistemenerji.com',
  address: 'Balıkesir, Türkiye',
  serviceArea: 'Balıkesir ve Bölge İllerde Hizmet',
  workingHours: 'Pazartesi - Cumartesi: 09:00 - 18:00',
};

export const navLinks = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Fineco Isı Pompası', href: '/fineco-isi-pompasi' },
  { label: 'Hizmetlerimiz', href: '/hizmetlerimiz' },
  { label: 'Reklam Tanıtımlarımız', href: '/reklam-tanitimlarimiz' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Sık Sorulan Sorular', href: '/sik-sorulan-sorular' },
  { label: 'İletişim', href: '/iletisim' },
];

export const legalLinks = [
  { label: 'KVKK Aydınlatma Metni', href: '/kvkk-aydinlatma-metni' },
  { label: 'Gizlilik Politikası', href: '/gizlilik-politikasi' },
  { label: 'Çerez Politikası', href: '/cerez-politikasi' },
  { label: 'Mesafeli Satış Sözleşmesi', href: '/mesafeli-satis-sozlesmesi' },
  { label: 'Ön Bilgilendirme Formu', href: '/on-bilgilendirme-formu' },
  { label: 'İptal ve İade Politikası', href: '/iptal-ve-iade-politikasi' },
  { label: 'Teslimat / Hizmet Süreci', href: '/teslimat-hizmet-sureci' },
  { label: 'Kullanım Şartları', href: '/kullanim-sartlari' },
];

export const heroBadges = [
  'Fineco Isı Pompaları Yetkili Bayisi',
  'Rezistans Takviyesiz',
  '%75 Hava Kaynaklı',
  'Mitsubishi Kompresörlü',
  'A+++ Yüksek Verim',
  'Balıkesir ve Bölge İllerde Hizmet',
];

export const problems = [
  { id: 1, text: 'Kömür ve yakıt zahmeti', icon: 'ri-fire-line' },
  { id: 2, text: 'Duman, kül ve bakım derdi', icon: 'ri-mist-line' },
  { id: 3, text: 'Mevsime göre konfor problemi', icon: 'ri-contrast-2-line' },
  { id: 4, text: 'Artan enerji maliyetleri', icon: 'ri-money-cny-circle-line' },
];

export const solutions = [
  { id: 1, text: 'Isıtma ve soğutma bir arada', icon: 'ri-sun-line' },
  { id: 2, text: 'Rezistans takviyesiz sistem', icon: 'ri-flashlight-line' },
  { id: 3, text: 'A+++ yüksek verim', icon: 'ri-battery-charge-line' },
  { id: 4, text: 'Şık tasarım', icon: 'ri-palette-line' },
  { id: 5, text: 'Profesyonel kurulum desteği', icon: 'ri-tools-line' },
];

export const advantages = [
  {
    id: 1,
    title: 'Rezistans Takviyesiz Sistem',
    description: 'Daha modern ve verimli çalışma prensibiyle ısıtma çözümü sunar.',
    icon: 'ri-shield-flash-line',
  },
  {
    id: 2,
    title: '%75 Hava Kaynaklı',
    description: 'Hava kaynaklı çalışma yapısıyla enerji verimliliği odaklı çözüm sağlar.',
    icon: 'ri-windy-line',
  },
  {
    id: 3,
    title: 'Mitsubishi Kompresörlü',
    description: 'Güçlü kompresör teknolojisiyle güven veren performans sunar.',
    icon: 'ri-cpu-line',
  },
  {
    id: 4,
    title: 'A+++ Yüksek Verim',
    description: 'Enerji verimliliği yüksek bir sistem tercih etmek isteyenler için güçlü seçenek.',
    icon: 'ri-flashlight-line',
  },
  {
    id: 5,
    title: 'Bakır İç Donanım',
    description: 'Türkiye\'de ilk bakır iç donanıma sahip ısı pompası yapısıyla uzun ömürlü kullanım.',
    icon: 'ri-copper-coin-line',
  },
  {
    id: 6,
    title: 'Şık Tasarım',
    description: 'Modern yaşam alanlarına uyum sağlayan estetik cihaz görünümü.',
    icon: 'ri-building-2-line',
  },
];

export const videos = [
  {
    id: 1,
    title: 'Yakıt Giderleri Yükselirken Akıllı Isıtmaya Geçin',
    description: 'Fineco Isı Pompası ile modern, verimli ve konforlu ısıtma çözümleri hakkında kısa tanıtım.',
    instagramLink: 'https://www.instagram.com/p/DbKj2d7MnJS/',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20villa%20exterior%20with%20dark%20anthracite%20heat%20pump%20unit%20installed%20on%20wall%2C%20energy%20efficiency%20visualization%20with%20green%20glow%20lines%2C%20professional%20architectural%20photography%2C%20clean%20modern%20aesthetic%2C%20warm%20natural%20lighting%2C%20premium%20residential%20setting&width=800&height=450&seq=video-thumb-1&orientation=landscape',
  },
  {
    id: 2,
    title: 'Fineco Isı Pompası ile 4 Mevsim Konfor',
    description: 'Dört mevsim boyunca ısıtma ve soğutma avantajı sunan Fineco Isı Pompası sistemlerini yakından tanıyın.',
    instagramLink: 'https://www.instagram.com/p/DacV9Q3jU9I/',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxury%20home%20living%20room%20interior%20with%20floor%20to%20ceiling%20windows%2C%20modern%20minimalist%20design%2C%20warm%20atmosphere%2C%20temperature%20comfort%20visualization%2C%20dark%20anthracite%20thermostat%20on%20wall%2C%20professional%20interior%20photography%2C%20soft%20natural%20light&width=800&height=450&seq=video-thumb-2&orientation=landscape',
  },
  {
    id: 3,
    title: 'Atak Sistem Enerji ile Bölgesel Hizmet',
    description: 'Balıkesir ve bölge illerde sunduğumuz profesyonel kurulum ve yönlendirme hizmetlerimizi keşfedin.',
    instagramLink: 'https://www.instagram.com/p/Dab1ioNs_8b/',
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20HVAC%20technician%20installing%20dark%20anthracite%20heat%20pump%20outdoor%20unit%20at%20modern%20villa%2C%20clean%20uniform%2C%20technical%20equipment%2C%20professional%20service%20scene%2C%20bright%20natural%20light%2C%20high%20quality%20photography&width=800&height=450&seq=video-thumb-3&orientation=landscape',
  },
];

export const services = [
  {
    id: 1,
    title: 'Fineco Isı Pompası Sistemleri',
    description: 'Isıtma ve soğutmayı bir arada sunan, modern ve yüksek verimli iklimlendirme çözümü.',
    icon: 'ri-temp-hot-line',
    whatsappMessage: 'Merhaba, Fineco Isı Pompası sistemleri hakkında detaylı bilgi almak istiyorum.',
  },
  {
    id: 2,
    title: 'Kat Kaloriferi Sistemleri',
    description: 'Yaşam alanlarına uygun kat kaloriferi çözümleri ve profesyonel yönlendirme.',
    icon: 'ri-radar-line',
    whatsappMessage: 'Merhaba, kat kaloriferi sistemleri hakkında bilgi almak istiyorum.',
  },
  {
    id: 3,
    title: 'Güneş Enerjisi Sistemleri',
    description: 'Enerji verimliliği ve uzun vadeli kullanım avantajı sunan güneş enerjisi çözümleri.',
    icon: 'ri-sun-line',
    whatsappMessage: 'Merhaba, güneş enerjisi sistemleri hakkında bilgi almak istiyorum.',
  },
];

export const suitableForGroups = [
  { id: 1, text: 'Müstakil ev sahipleri', icon: 'ri-home-4-line' },
  { id: 2, text: 'Villa sahipleri', icon: 'ri-building-4-line' },
  { id: 3, text: 'Doğalgaz olmayan bölgeler', icon: 'ri-map-pin-line' },
  { id: 4, text: 'İş yerleri', icon: 'ri-store-2-line' },
  { id: 5, text: 'Geniş yaşam alanları', icon: 'ri-aspect-ratio-line' },
  { id: 6, text: 'Yeni sistem kurmak isteyenler', icon: 'ri-tools-line' },
  { id: 7, text: 'Kömür ve soba zahmetinden kurtulmak isteyenler', icon: 'ri-forbid-2-line' },
  { id: 8, text: 'Isıtma ve soğutmayı tek sistemde isteyenler', icon: 'ri-contrast-2-line' },
];

export const processSteps = [
  {
    id: 1,
    title: 'Bize Ulaşırsınız',
    description: 'WhatsApp veya telefon üzerinden bilgi talebi oluşturursunuz.',
    icon: 'ri-chat-3-line',
  },
  {
    id: 2,
    title: 'İhtiyacınızı Anlarız',
    description: 'Bulunduğunuz bölge, alan büyüklüğü ve mevcut sisteminiz değerlendirilir.',
    icon: 'ri-search-eye-line',
  },
  {
    id: 3,
    title: 'Size Uygun Sistem Belirlenir',
    description: 'İhtiyacınıza göre Fineco Isı Pompası veya diğer sistem seçenekleri değerlendirilir.',
    icon: 'ri-check-double-line',
  },
  {
    id: 4,
    title: 'Teklif ve Süreç Paylaşılır',
    description: 'Uygun sistem, fiyat ve uygulama süreci hakkında bilgi verilir.',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 5,
    title: 'Kurulum Planlanır',
    description: 'Onay sonrası profesyonel kurulum süreci başlatılır.',
    icon: 'ri-calendar-check-line',
  },
];

export const trustItems = [
  { id: 1, text: 'Fineco Isı Pompaları Yetkili Bayisi', icon: 'ri-verified-badge-line' },
  { id: 2, text: 'Balıkesir ve bölge illerde hizmet', icon: 'ri-map-pin-2-line' },
  { id: 3, text: 'Profesyonel yönlendirme', icon: 'ri-compass-3-line' },
  { id: 4, text: 'Kaliteli ürün seçimi', icon: 'ri-star-line' },
  { id: 5, text: 'Kurulum ve uygulama desteği', icon: 'ri-settings-3-line' },
  { id: 6, text: 'Bilgi ve sipariş desteği', icon: 'ri-customer-service-2-line' },
];

export const faqItems = [
  {
    id: 1,
    question: 'Fineco Isı Pompası hangi alanlarda kullanılabilir?',
    answer: 'Müstakil ev, villa, iş yeri ve uygun altyapıya sahip farklı yaşam alanlarında değerlendirilebilir.',
  },
  {
    id: 2,
    question: 'Isı pompası hem ısıtma hem soğutma yapar mı?',
    answer: 'Evet, uygun sistem ve kurulumla ısıtma ve soğutma avantajı sunabilir.',
  },
  {
    id: 3,
    question: 'Doğalgaz olmayan bölgelerde kullanılabilir mi?',
    answer: 'Evet, özellikle doğalgaz olmayan bölgelerde alternatif modern ısıtma çözümü olarak değerlendirilebilir.',
  },
  {
    id: 4,
    question: 'Fiyat nasıl belirlenir?',
    answer: 'Fiyat; alan büyüklüğü, kullanım ihtiyacı, cihaz kapasitesi ve kurulum şartlarına göre değişir.',
  },
  {
    id: 5,
    question: 'Keşif veya bilgi almak için ne yapmalıyım?',
    answer: 'WhatsApp üzerinden bize ulaşarak bulunduğunuz bölge, ısıtılacak alan ve mevcut sistem bilgilerinizi paylaşabilirsiniz.',
  },
  {
    id: 6,
    question: 'Balıkesir dışında hizmet var mı?',
    answer: 'Balıkesir ve bölge illerde hizmet verilmektedir. Detay için WhatsApp üzerinden bilgi alabilirsiniz.',
  },
];

export const finecoPageFaqs = [
  {
    id: 1,
    question: 'Fineco Isı Pompası nedir?',
    answer: 'Fineco Isı Pompası; rezistans takviyesiz yapısıyla havadaki enerjiyi kullanarak ısıtma ve soğutma sağlayan, yüksek verimli bir iklimlendirme sistemidir.',
  },
  {
    id: 2,
    question: 'Rezistans takviyesiz olması ne anlama gelir?',
    answer: 'Rezistans takviyesiz yapı, cihazın elektrikli ısıtıcı desteğine ihtiyaç duymadan çalışabildiğini ifade eder. Bu da daha verimli ve düşük enerji tüketimli bir kullanım anlamına gelir.',
  },
  {
    id: 3,
    question: 'Fineco Isı Pompası hangi iklim koşullarında çalışır?',
    answer: 'Fineco Isı Pompaları, geniş bir sıcaklık aralığında çalışabilecek şekilde tasarlanmıştır. Bölgenizin iklim koşullarına uygun kapasite seçimi için bizimle iletişime geçebilirsiniz.',
  },
  {
    id: 4,
    question: 'Kurulum süreci nasıl işler?',
    answer: 'Keşif, ihtiyaç analizi, uygun sistem belirleme ve profesyonel kurulum aşamalarıyla ilerler. Detaylı bilgi için WhatsApp üzerinden bize ulaşabilirsiniz.',
  },
  {
    id: 5,
    question: 'Bakım gerektirir mi?',
    answer: 'Fineco Isı Pompaları düzenli periyodik bakım ile uzun yıllar verimli şekilde kullanılabilir. Bakım ihtiyacı ve sıklığı hakkında bilgi almak için bizimle iletişime geçin.',
  },
];

export const technicalAdvantages = [
  'Rezistans takviyesiz yapı',
  '%75 hava kaynaklı çalışma mantığı',
  'Rezistans içermeyen sistem',
  'Türkiye\'de ilk bakır iç donanıma sahip yapı',
  'Mitsubishi kompresörlü teknoloji',
  'A+++ enerji verimliliği',
  'Şık tasarım',
  'Isıtma ve soğutma fonksiyonu',
];

export const serviceDetails = [
  {
    id: 1,
    title: 'Fineco Isı Pompası Sistemleri',
    description: 'Isıtma ve soğutmayı bir arada sunan, modern ve yüksek verimli iklimlendirme çözümü. Rezistans takviyesiz yapısı, %75 hava kaynaklı çalışma prensibi ve Mitsubishi kompresör teknolojisiyle yaşam alanlarınız için konforlu ve verimli bir seçenek.',
    advantages: [
      'Isıtma ve soğutma tek sistemde',
      'Rezistans takviyesiz yapı',
      'A+++ enerji verimliliği',
      'Mitsubishi kompresör teknolojisi',
      'Bakır iç donanım',
      'Şık ve modern tasarım',
    ],
    suitableFor: [
      'Müstakil evler',
      'Villalar',
      'Doğalgaz olmayan bölgeler',
      'Geniş yaşam alanları',
    ],
    whatsappMessage: 'Merhaba, Fineco Isı Pompası sistemleri hakkında detaylı bilgi almak istiyorum.',
  },
  {
    id: 2,
    title: 'Kat Kaloriferi Sistemleri',
    description: 'Yaşam alanlarınıza uygun kat kaloriferi çözümleriyle konforlu ve verimli ısıtma sistemleri. Profesyonel yönlendirme ve bölgenize uygun sistem seçimi için bizimle iletişime geçin.',
    advantages: [
      'Alan ısıtmasında etkili çözüm',
      'Mekana özel sıcaklık kontrolü',
      'Uzun ömürlü kullanım',
      'Profesyonel kurulum desteği',
      'Bölgesel servis avantajı',
    ],
    suitableFor: [
      'Müstakil evler',
      'Apartman daireleri',
      'İş yerleri',
      'Yeni yapı projeleri',
    ],
    whatsappMessage: 'Merhaba, kat kaloriferi sistemleri hakkında bilgi almak istiyorum.',
  },
  {
    id: 3,
    title: 'Güneş Enerjisi Sistemleri',
    description: 'Enerji verimliliği ve uzun vadeli kullanım avantajı sunan güneş enerjisi çözümleri. Yenilenebilir enerji kaynaklarıyla yaşam alanlarınız için sürdürülebilir ve ekonomik çözümler.',
    advantages: [
      'Yenilenebilir enerji kaynağı',
      'Uzun vadeli tasarruf avantajı',
      'Çevre dostu çözüm',
      'Enerji bağımsızlığı',
      'Düşük bakım maliyeti',
    ],
    suitableFor: [
      'Müstakil evler',
      'Villalar',
      'İş yerleri',
      'Geniş çatı alanına sahip yapılar',
    ],
    whatsappMessage: 'Merhaba, güneş enerjisi sistemleri hakkında bilgi almak istiyorum.',
  },
];